import styled from 'styled-components'
import { mbSize, Media } from '../../../../theme'

export const Wrapper = styled.div`
  width: 100%;
  background: #fdb62ccc;
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  padding: 8px 0;
  color: #ffffff;
  font-size: 16px;
  ${Media.lessThan(Media.small)} {
    flex-direction: column;
    align-items: center;
    padding: ${mbSize(14)} 0;
    font-size: ${mbSize(24)};
    line-height: ${mbSize(36)};
  }
`

export const Dismiss = styled.div`
  font-weight: 700;
  text-decoration: underline;
  margin-left: 40px;
  color: #ffffff;
  cursor: pointer;
  ${Media.lessThan(Media.small)} {
    margin-left: ${mbSize(40)};
  }
`

export const SecondLine = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 4px;
  a {
    color: #ffffff;
    text-decoration: underline;
    margin-left: 4px;
  }
  ${Media.lessThan(Media.small)} {
    margin-left: unset;
    a {
      margin-left: ${mbSize(6)};
    }
  }
`
